import { Box } from "@material-ui/core";
import ConnectMenu from "./ConnectMenu.jsx";
import styled from 'styled-components'
import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi'

import "./topbar.scss";

function TopBar({ theme, setNotification }) {

  const [hamburgeropen, setHamburgerOpen] = useState(false);

  const dialog = useRef();

  useEffect(() => {

    document.addEventListener('mouseup', function (event) {
      if (dialog.current && !dialog.current.contains(event.target)) {
        setHamburgerOpen(false);
      }
    });
  }, []);

  return (

    <StyledContainer>
      <NavBar>
        <Box display={'flex'} alignItems={'center'}>
          <Box width={'180px'} height={'90px'}>
            <img src={'/logo.png'} alt={'logo'} width={'100%'} height={'100%'} />
          </Box>
        </Box>
        <Hamburger mt={'10px'} onClick={() => setHamburgerOpen(!hamburgeropen)}><GiHamburgerMenu /></Hamburger>
        <Menus>
          <Link to={'/'} ><Box  >REWARD</Box></Link>
          <Link to={'/pool'}><Box   >POOL</Box></Link>
          <ConnectMenu theme={theme} setNotification={setNotification} />
        </Menus>
      </NavBar>
      <div ref={dialog}>
        <HamburgerMenus open={hamburgeropen}>
          <Link to={'/'}><Box onClick={() => setHamburgerOpen(false)} mt={'20px'}> REWARD</Box></Link>
          <Link to={'/pool'}><Box onClick={() => setHamburgerOpen(false)}>POOL</Box></Link>
          <Box onClick={() => setHamburgerOpen(false)}><ConnectMenu theme={theme} /></Box>
        </HamburgerMenus>
      </div>
    </StyledContainer>
  );
}

const NavBar = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width : 1100px;
    margin : 0 auto;
    padding : 0 20px;

`;
const StyledContainer = styled(Box)`
    width: 100%;
    color : white;
    background: rgba(25, 43, 68, 1);
    position : relative;
    z-index : 100;
`;

const Hamburger = styled(Box)`
    display : none;
    cursor : pointer;
    font-size : 48px;
    @media screen and (max-width : 450px){
        display : unset;
    }
`;

const Menus = styled(Box)`
    display : flex;
    align-items : center;
    >a{
      text-decoration : none;
    }
    >a>div{
      color : white;
      cursor : pointer;
      transition : all 0.3s;
      :hover{
        color : #2ddd4d;
      }
      font-size : 15px;
      font-weight : bold;
      padding : 0 24px;
    }
    @media screen and (max-width : 450px){
        display : none;
    }
`;

const HamburgerMenus = styled(Box)`
    position : absolute;
    left : 0;
    top : 90px;
    width : 100%;
    background : rgba(25, 43, 68, 1);
    >a{
      text-decoration : none;
    }
    >a>div{
        padding : 12px 0px;
        color : white;
        font-size : 15px;
        text-align : center;
        transition : all 0.3s;
        border-radius : 16px;
        :hover{
            background : #2ddd4d;
        }
    }
    transition : all 0.3s;
    height : ${({ open }) => open ? '165px ' : '0'};
    overflow : hidden;
`;

export default TopBar;
